/* @ngInject */
const statCtrl = (
  $scope,
) => {
}

export default statCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/stat/stat.controller.js